export default function(bool: boolean): string {
  return bool ? "Y" : "N";
}
